import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon_circleChevronDown",
  "use": "icon_circleChevronDown-usage",
  "viewBox": "0 0 28 28",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 28 28\" id=\"icon_circleChevronDown\"><rect x=\"28\" y=\"28\" width=\"28\" height=\"28\" rx=\"14\" transform=\"rotate(-180 28 28)\" fill=\"#98A5AD\" /><path d=\"M13.482 18.165L7.548 12.23a.733.733 0 010-1.037l.692-.692a.733.733 0 011.035-.001L14 15.204l4.725-4.703a.733.733 0 011.035.001l.692.692a.733.733 0 010 1.037l-5.934 5.934a.733.733 0 01-1.036 0z\" fill=\"#fff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol